export default function Logo({ className }: { className: string }) {
  return (
    <svg viewBox="0 0 1260 400" className={className}>
      <polygon points="430,0 430,66.7 430,133.3 430,200 430,266.7 430,400 630,400 630,266.7 730,266.7 730,200 730,133.3 830,133.3 830,66.7 830,0 630,0" />
      <polygon points="200,200 0,0 0,400 200,400 400,400 400,200 400,0 200,0" />
      <path d="M1060,0H860v200v200h200c110.5,0,200-89.5,200-200S1170.5,0,1060,0z" />
    </svg>
  )
}
